'use client'

export const AxeptioButton = ({ children }: { children: React.ReactNode }) => (
	<button
		className='hover:text-primary'
		onClick={() => window.openAxeptioCookies()}
		type='button'
	>
		{children}
	</button>
)
